<script setup lang="ts">
import type { Subscription } from '@entities/subscription'

import { AppSelectSearchable } from '@shared/ui/selects'

import { useSubscriptionDealOwner } from '../model/subscription-deal-owner.hook'

defineOptions({
  name: 'SubscriptionDealOwner',
})

const props = withDefaults(defineProps<{
  subscription: Subscription
  /** The owner shown — the saved one in the table, the edited draft in the details modal. */
  agentId: number | null
  label?: string
  disabled?: boolean
}>(), {
  label: undefined,
  disabled: false,
})

const emit = defineEmits<{
  'update:agent-id': [agentId: number | null]
}>()

const {
  refValue,
  options,
} = useSubscriptionDealOwner({
  subscription: computed(() => props.subscription),
  agentId: computed(() => props.agentId),
  onChange: agentId => emit('update:agent-id', agentId),
})
</script>

<template>
  <AppSelectSearchable
    v-model="refValue"
    class="subscription-deal-owner"
    :options="options"
    :label="label"
    :disabled="disabled"
    placeholder="Select deal owner"
  />
</template>

<style scoped lang="scss" src="./SubscriptionDealOwner.scss" />
